import { API_URL } from '@hellodarwin/core/lib/api';
import { useLogin } from '@hellodarwin/app-core/lib/providers/login-provider';
import { usePlatform } from '@hellodarwin/core/lib/features/providers/platform-provider';
import { useMemo } from 'react';
import { ApiClient } from '../../../api/api';
import { AcceptedGrantsAPI } from '../services/AcceptedGrantsAPI';
export const useApiUrl = () => {
    const { app } = usePlatform();
    return useMemo(() => `${API_URL}/${app}`, [app]);
};
export const useAcceptedGrantsApi = () => {
    const { accessToken } = useLogin();
    const baseApiUrl = useApiUrl();
    return new AcceptedGrantsAPI(new ApiClient({ accessToken, baseApiUrl }));
};
